export default "__VITE_ASSET__Bqp_dEXQ__"